/*
 * Maison Jaouhara — mobile-only motion controller.
 * ------------------------------------------------------------------
 * Companion script for snippets/mj-mobile-motion.liquid.
 *
 * - Does nothing at all outside max-width:749px or when the user has
 *   requested reduced motion — in both cases every [data-mj-observe]
 *   element is simply revealed immediately (its CSS entrance state is
 *   already gated behind the same two conditions, so nothing needs to
 *   be "undone" here — see the stylesheet's own media/prefers gates).
 * - Watches every [data-mj-observe] element with a single shared
 *   IntersectionObserver. When an element crosses into view, it gets
 *   the `.mj-mo-in` class once and is then unobserved — animations run
 *   once per page load, never replay on re-scroll.
 * - Falls back to revealing everything immediately if IntersectionObserver
 *   isn't available.
 */
(function () {
  'use strict';

  function revealAll(elements) {
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.add('mj-mo-in');
    }
  }

  function init() {
    var elements = document.querySelectorAll('[data-mj-observe]');
    if (!elements.length) return;

    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (reducedMotion || !isMobile || !('IntersectionObserver' in window)) {
      revealAll(elements);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            entry.target.classList.add('mj-mo-in');
            observer.unobserve(entry.target);
          }
        }
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    for (var j = 0; j < elements.length; j++) {
      observer.observe(elements[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
